export default __webpack_public_path__ + "static/ananas-f7d30eef066de3d8e67297e072e57fb6.png";